import PropTypes from 'prop-types';
import { Navbar, Footer, CookieConsent } from 'components';
// import FooterView from 'components/Footer/presentational';

function Layout({ children }) {
    return (
        <>
            <Navbar />
            {children}
            <Footer />
            <CookieConsent />
        </>
    );
}
Layout.propTypes = {
    children: PropTypes.object.isRequired,
};
export default Layout;
